export const opentLink = (id) => {
  // window.open("/modelviewer/" + btoa(id), "_blank");
  window.location.href = "/modelviewer/" + btoa(id);
};
